import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <p className="footer-text">
            © {new Date().getFullYear()} AI for Law Firms. All rights reserved.
          </p>
        </div>
        
        <div className="footer-section footer-links">
          <Link to="/terms" className="footer-link">Terms & Conditions</Link>
          <span className="footer-divider">|</span>
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <span className="footer-divider">|</span>
          <Link to="/disclaimers" className="footer-link">Disclaimers</Link>
        </div>

        <div className="footer-section">
          <p className="footer-disclaimer">
            This platform does not provide legal advice. AI can make mistakes.
          </p>
          <p className="footer-support-email">
            <a href="mailto:sales@lawra-ai.com">sales@lawra-ai.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
